import { Box, Icon } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const MissingAlert = () => (
  <Box flexDirection={'row'} justifyContent={'flexStart'}>
    <Icon.Medium icon="alert-sign" color="radicalRed1000" />
    <Box paddingX="s24">
      {i18n.t('payroll_integrations.incidences.datev_lauds.import.table.missing')}
    </Box>
  </Box>
)

export default MissingAlert
